import React, {createContext, useContext, useReducer} from 'react'
import {ThinClientOverviewReducer} from "../reducer/ThinClientOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const ThinClientOverviewContext = createContext();

const ThinClientOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        thinClientDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true,
        loadingStatusDevices: {}
    }
    const [viewModel, dispatch] = useReducer(ThinClientOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }

    return (
        <ThinClientOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </ThinClientOverviewContext.Provider>
    )
}

export default ThinClientOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/context/ThinClientOverviewContext.js